export const formatDateNew = input => {
  if (!input) return input;

  const dateTimeParts = input.split("T");
  return dateTimeParts[0];
};

export const parseDateNew = input => {
  if (!input) return input;

  return `${input}T00:00:00.0000000Z`;
};

export const formatDate = input => {
  if (!input) return input;

  const dateParts = input.split("/");
  return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
};

export const parseDate = input => {
  if (!input) return input;

  const dateParts = input.split("-");
  return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
};

export const formatDateTime = input => {
  if (!input) return input;

  const dateTimeParts = input.split(" ");
  const dateParts = dateTimeParts[0].split("/");
  const timeParts = dateTimeParts[1].split(":");

  return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timeParts[0]}:${timeParts[1]}`;
};

export const parseDateTime = input => {
  if (!input) return input;

  const dateTimeParts = input.split("T");
  const dateParts = dateTimeParts[0].split("-");
  const timeParts = dateTimeParts[1].split(":");

  return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]} ${timeParts[0]}:${timeParts[1]}`;
};
